import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import Collapse from 'rc-collapse';
import 'rc-collapse/assets/index.css';
import classNames from 'classnames';
import Context from '../context';
const Panel = Collapse.Panel;



class QAGroup extends Component {


    renderQuestions(questions, label) {
        return (<Panel header={label} headerClass="panel-header question">
            {
                questions.map(function (question, index) {
                    let audio = question.audio;
                    return <Context audio={audio} script={question.script} key={index} />
                })
            }
        </Panel>);
    }


    renderPossibleAnswers(possibleAnswers) {
        return (<Panel header="Possible Answers" headerClass="panel-header">
            {
                possibleAnswers.map(function (possibleAnswer, index) {
                    let audio = possibleAnswer.audio;
                    return <Context audio={audio} script={possibleAnswer.script} key={index} />
                })
            }
        </Panel>);

    }


    renderProblematicAnswers(problematicAnswers) {
        return (<Panel header="Problematic Answers" headerClass="panel-header">
            {
                <div className={"problematic-answers-table"}>
                    {
                        problematicAnswers.map(function(problematicAnswer, index) {
                            let label           = "variation #" + (index + 1) + " & comment";
                            let probAnswerAudio = problematicAnswer.probAnswer.audio;
                            let commentAudio    = problematicAnswer.comment.audio;
                            return (
                                <div key={index} className={"row"}>
                                    <div className={"col-sm-2"}>{label}</div>
                                    <div className={"col-sm-5"}><Context vertical audio={probAnswerAudio} script={problematicAnswer.probAnswer.script}/></div>
                                    <div className={"col-sm-5"}><Context vertical audio={commentAudio} script={problematicAnswer.comment.script}/></div>
                                </div>
                            )
                        })
                    }
                </div>
            }
        </Panel>);
    }

    render() {
        const {className, QA} = this.props;
        const gropuCls = classNames("QA-group", className);
        if (QA) {
            const { questions, possibleAnswers, problematicAnswers } = QA;
            let label = "Question #" + (this.props.index + 1);
            return (
                <div className={gropuCls}>
                    <Collapse accordion={true}>
                        {questions && questions.length >= 1 && this.renderQuestions(questions, label)}
                        {possibleAnswers && possibleAnswers.length >= 1 && this.renderPossibleAnswers(possibleAnswers)}
                        {problematicAnswers && problematicAnswers.length >= 1 && this.renderProblematicAnswers(problematicAnswers)}
                    </Collapse>
                </div>
            );
        } else {
            return (
                <div>Empty</div>
            )
        }

    }
}


QAGroup.propTypes = {
    QA: PropTypes.object,
};


export default QAGroup;